angular.module('unergie.main')
.filter('billEnergyType', () =>
    function (val) {
        switch (val) {
            case 'MIX':
                return '0% électricité verte'
            case 'THIRD':
                return '30% Électricité renouvelable'
            case 'HALF':
                return '50% électricité verte'
            case 'GREEN':
                return `100% électricité verte`
            default:
                return `${val}% électricité verte`
        }
    },
)
.filter('billEnergyTypeShort', () =>
    function (val) {
        switch (val) {
            case 'MIX':
                return '0%'
            case 'THIRD':
                return '30%'
            case 'HALF':
                return '50%'
            case 'GREEN':
                return `100%`
            default:
                return `${val}%`
        }
    },
)
.filter('billPaymentMode', () =>
    function (val) {
        switch (val) {
            case 'FACTORING':
            case 'TRANSFER':
                return 'Virement'
            case 'SEPA':
                return `Prélèvement`
            default:
                return val
        }
    },
)
.filter('billPaymentModeAdmin', () =>
    function (val) {
        switch (val) {
            case 'TRANSFER':
                return 'Virement'
            case 'SEPA':
                return `Prélèvement`
            case 'FACTORING':
                return `Affacturage`
            default:
                return val
        }
    },
)
.filter('billPaymentFrequency', () =>
    function (val) {
        switch (val) {
            case 'MONTHLY':
                return 'Mensuelle'
            case 'BIMONTHLY':
                return `Bimestrielle`
            case 'BIANNUAL':
                return 'Semestrielle'
            default:
                return val
        }
    },
)
